module.exports = __webpack_public_path__ + "img/帮助中心.942d9999.png";